import { Router } from '@angular/router';

export const DATA_DELETION_PATH = '/data-deletion';
export const CAMERA_DOCS_PATH = '/camera-docs';

/** Pages that render without the account shell and never trigger sign-in redirects. */
export const PUBLIC_PAGE_PATHS: readonly string[] = [DATA_DELETION_PATH, CAMERA_DOCS_PATH];

export function isPublicPageUrl(url: string): boolean {
  const path = (url || '').split(/[?#]/)[0].replace(/\/$/, '');
  return PUBLIC_PAGE_PATHS.includes(path);
}

export function isPublicPageNavigation(router: Router): boolean {
  const navigation = router.getCurrentNavigation();
  return isPublicPageUrl(navigation?.extractedUrl.toString() || router.url);
}
